<template>
  <CustCard
    :title="$l('form_header_doc') || '客户文档'"
    :desc="$l('form_desc_doc') || '浏览所有已经上传的该客户文档'"
    v-loading="loading"
  >
    <FolderHeader
      ref="header"
      class="mb-1"
      @query="getData"
      @create-folder="openFolderForm({ type: 'add' })"
      @upload-doc="uploadDocVisible = true"
    />
    <FolderBreadcrumb
      class="my-2"
      :parentCode="parentCode || custCode"
      @openFolder="openFolder"
    />
    <FolderTable
      :tableData="tableData"
      @openFolder="openFolder"
      @reload="reload"
      @edit-folder="editFolder"
      @move-folder="moveFolder"
      @move-doc="moveDoc"
      @edit-doc="editDoc"
      @deactivate-doc="deactivateDoc"
      @enable-doc="enableDoc"
    />

    <FolderForm
      :visible.sync="folderFormOpts.visible"
      :type="folderFormOpts.type"
      :custFolderCode="folderFormOpts.custFolderCode"
      :custCode="custCode"
      :parentCode="parentCode"
      @reload="reload"
    />

    <UploadDoc
      :visible.sync="uploadDocVisible"
      :custFolderCode="parentCode"
      :custCode="custCode"
      @reload="reload"
    />

    <MoveFolder
      :visible.sync="moveFolderOpts.visible"
      :custFolderCode="moveFolderOpts.custFolderCode"
      :parentCode="moveFolderOpts.parentCode || custCode"
      :custCode="custCode"
      @reload="reload"
    />

    <MoveDoc
      :visible.sync="moveDocOpts.visible"
      :custDocCode="moveDocOpts.custDocCode"
      :custFolderCode="moveDocOpts.parentCode || custCode"
      :custCode="custCode"
      @reload="reload"
    />

    <DocForm
      :visible.sync="docFormOpts.visible"
      :custDocCode="docFormOpts.custDocCode"
      @reload="reload"
    />

    <DeactivateDoc
      :visible.sync="deactivateDocOpts.visible"
      :custDocCode="deactivateDocOpts.custDocCode"
      @reload="reload"
    />

    <EnableDoc
      :visible.sync="enableDocOpts.visible"
      :custDocCode="enableDocOpts.custDocCode"
      @reload="reload"
    />
  </CustCard>
</template>

<script>
import CustCard from '../cust-card'
import FolderHeader from './components/folder-header'
import FolderBreadcrumb from './components/folder-breadcrumb'
import FolderTable from './components/folder-table'
import FolderForm from './components/folder-form'
import UploadDoc from './components/upload-doc'
import MoveFolder from './components/move-folder'
import MoveDoc from './components/move-doc'
import DocForm from './components/doc-form'
import DeactivateDoc from './components/deactivate-doc'
import EnableDoc from './components/enable-doc'
export default {
  components: {
    CustCard,
    FolderHeader,
    FolderBreadcrumb,
    FolderTable,
    FolderForm,
    UploadDoc,
    MoveFolder,
    MoveDoc,
    DocForm,
    DeactivateDoc,
    EnableDoc,
  },
  props: {
    custCode: { type: String, default: '' },
  },
  data() {
    return {
      parentCode: '',
      loading: false,
      tableData: [],
      folderFormOpts: { visible: false, type: '', custFolderCode: '' },
      uploadDocVisible: false,
      moveFolderOpts: { visible: false, custFolderCode: '', parentCode: '' },
      moveDocOpts: { visible: false, custDocCode: '', parentCode: '' },
      docFormOpts: { visible: false, custDocCode: '' },
      deactivateDocOpts: { visible: false, custDocCode: '' },
      enableDocOpts: { visible: false, custDocCode: '' },
    }
  },
  activated() {
    this.reload(true)
  },
  methods: {
    reload(isReset = false) {
      this.$refs.header.query({ isReset })
    },
    async getData(form) {
      if (this.isEnableSearch(form)) this.parentCode = ''

      this.loading = true
      const res = await this.$api
        .masterCustomerFolderListApi({
          custCode: this.custCode,
          parentCode: this.parentCode,
          ...form,
        })
        .catch(() => null)
      this.loading = false
      this.tableData = res?.body?.data
    },
    openFolderForm({ type = '', custFolderCode } = {}) {
      this.folderFormOpts = { visible: true, type, custFolderCode }
    },
    openFolder({ custFolderCode }) {
      this.parentCode = custFolderCode
      this.reload(true)
    },
    editFolder({ custFolderCode }) {
      this.openFolderForm({ type: 'edit', custFolderCode })
    },
    moveFolder({ custFolderCode, parentCode }) {
      this.moveFolderOpts = { visible: true, custFolderCode, parentCode }
    },
    moveDoc({ custDocCode, parentCode }) {
      this.moveDocOpts = { visible: true, custDocCode, parentCode }
    },
    editDoc({ custDocCode }) {
      this.docFormOpts = { visible: true, custDocCode }
    },
    deactivateDoc({ custDocCode }) {
      this.deactivateDocOpts = { visible: true, custDocCode }
    },
    enableDoc({ custDocCode }) {
      this.enableDocOpts = { visible: true, custDocCode }
    },
    isEnableSearch(form) {
      if (!form) return false

      let result
      const keys = Object.keys(form)
      for (let i = 0; i < keys.length; i++) {
        const value = form[keys[i]]
        if (value && Array.isArray(value)) {
          result = !!value?.length
        } else {
          result = !!value
        }

        if (result) return true
      }
      return false
    },
  },
}
</script>
